/*
 * Smoothie Bar buy box + $2 boost add-ons controller (AAC, issue #176).
 * Self-contained: Protein variant choice (if any) + qty + multi-select boosts + live total, submitted
 * as one multi-line /cart/add (smoothie line + one line per checked boost, each with an
 * "Add-on for: <smoothie>" property). No selling plan, no framework; self-running + idempotent.
 * Mirrors component-offseason-signup.js.
 */
(function () {
  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function init(root) {
    if (!root || root.__skSbBound) return;
    root.__skSbBound = true;

    var cfgEl = root.querySelector('[data-sk-sb-config]');
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var variants = cfg.variants || [];
    // One radio group per product option (Size, Protein, …), keyed by data-opt-index.
    var optRadios = Array.prototype.slice.call(root.querySelectorAll('input[data-opt-index]'));
    var optGroups = {};
    optRadios.forEach(function (r) {
      var i = r.getAttribute('data-opt-index');
      (optGroups[i] = optGroups[i] || []).push(r);
    });
    var optIndexes = Object.keys(optGroups).sort(function (a, b) { return a - b; });

    var boostChecks = Array.prototype.slice.call(root.querySelectorAll('.sk-sb__boost input[type="checkbox"]'));
    var priceEl = root.querySelector('[data-sk-sb-price]');
    var totalEl = root.querySelector('[data-sk-sb-total]');
    var qtyEl = root.querySelector('[data-sk-sb-qty]');
    var decBtn = root.querySelector('[data-sk-sb-dec]');
    var incBtn = root.querySelector('[data-sk-sb-inc]');
    var submitEl = root.querySelector('[data-sk-sb-submit]');
    var errorEl = root.querySelector('[data-sk-sb-error]');

    function selectedOptions() {
      return optIndexes.map(function (i) {
        var group = optGroups[i];
        for (var j = 0; j < group.length; j++) { if (group[j].checked) return group[j].value; }
        return group[0].value;
      });
    }

    function selectedVariant() {
      if (!optIndexes.length) return { id: cfg.firstVariantId, price: cfg.firstPrice };
      var sel = selectedOptions();
      for (var i = 0; i < variants.length; i++) {
        var vo = variants[i].options || [];
        if (vo.length === sel.length && vo.every(function (o, k) { return o === sel[k]; })) {
          return { id: variants[i].id, price: variants[i].price };
        }
      }
      return { id: cfg.firstVariantId, price: cfg.firstPrice };
    }

    function qty() {
      var q = parseInt(qtyEl ? qtyEl.value : '1', 10);
      if (!q || q < 1) q = 1;
      return q;
    }

    function checkedBoosts() {
      return boostChecks.filter(function (c) { return c.checked; }).map(function (c) {
        return { id: parseInt(c.getAttribute('data-variant-id'), 10), price: parseInt(c.getAttribute('data-price'), 10) };
      });
    }

    function recalc() {
      var v = selectedVariant();
      var cents = v.price * qty();
      checkedBoosts().forEach(function (b) { cents += b.price; });
      if (priceEl) priceEl.textContent = money(v.price);
      if (totalEl) totalEl.textContent = money(cents);
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = !msg;
    }

    optRadios.forEach(function (r) { r.addEventListener('change', recalc); });
    boostChecks.forEach(function (c) { c.addEventListener('change', recalc); });
    if (qtyEl) qtyEl.addEventListener('input', recalc);
    if (decBtn) decBtn.addEventListener('click', function () { if (qtyEl) { qtyEl.value = Math.max(1, qty() - 1); recalc(); } });
    if (incBtn) incBtn.addEventListener('click', function () { if (qtyEl) { qtyEl.value = qty() + 1; recalc(); } });

    function submit() {
      showError('');
      var v = selectedVariant();
      var line = { id: v.id, quantity: qty() };
      // Special Instructions (monorepo #1042): only on the smoothie line, and only when not blank, so an
      // untouched box adds nothing to the order (same rule as the sandwich builder).
      var notesEl = root.querySelector('[data-sk-sb-notes]');
      var notes = notesEl ? notesEl.value.replace(/^\s+|\s+$/g, '') : '';
      if (notes) line.properties = { 'Special Instructions': notes };
      var items = [line];
      checkedBoosts().forEach(function (b) {
        items.push({ id: b.id, quantity: 1, properties: { 'Add-on for': cfg.productTitle } });
      });

      submitEl.disabled = true;
      submitEl.textContent = 'Adding…';
      fetch(root.getAttribute('data-cart-add'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (b) { return { ok: res.ok, body: b }; }); })
        .then(function (r) {
          if (!r.ok) {
            showError((r.body && r.body.description) || 'Could not add to cart. Please try again.');
            submitEl.disabled = false;
            submitEl.textContent = 'Add to Cart';
            return;
          }
          window.location.href = root.getAttribute('data-cart-url') || '/cart';
        })
        .catch(function () {
          showError('Network error. Please try again.');
          submitEl.disabled = false;
          submitEl.textContent = 'Add to Cart';
        });
    }

    if (submitEl) submitEl.addEventListener('click', submit);
    recalc();
  }

  function boot() {
    document.querySelectorAll('[data-sk-sb]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
